export default "__VITE_ASSET__COmxDCBR__"